
export default {
  name: 'MoleculeCreator'
}
